export default (tourCriteria) => {
    const params = {};
    const element = tourCriteria.get('resorts');
    if (element?.length) {
        params.toCity = element.pluck('id').join('.');
    }

    return params;
};